export { TransmissionIcon } from "./transmission";
